import { gql } from '@/utilities/gql';
import { NARRATIVE_CARD_ACTIONS_FRAGMENT } from '../NarrativeCardActions';

export const NARRATIVE_CARD_SYNTHETIC_FRAGMENT = gql(
  `
  fragment NarrativeCardSyntheticFields on Narrative @_unmask {
    id
    title
    type
    slug
    primaryCount
    valuation {
      type
      fairValue
      intrinsicDiscount
    }
    company {
      id
      tickerSymbol
      name
      canonicalURL
      data {
        currencyInfo
      }
      info {
        url
      }
      analysisValue {
        priceTargetAnalystCount
      }
    }
    ...NarrativeCardActionsFields
  }
`,
  [NARRATIVE_CARD_ACTIONS_FRAGMENT]
);
